export interface CategoriesType {
    _id: string;
    name: string;
    nameKH: string;
}

export const productStatus = {
    Pending: 1,
    Reject: 2,
    Accept: 3,
    Process: 4,
    Ready: 5,
    Completed: 6,
    Return: 7
};

export const ProductType = {
    product: 1,
    addOns: 2,
    free: 3
};

export interface TableType {
    _id: string;
    name: string;
    nameKh: string;
    isAvailable: boolean;
    orderCount: number;
    type: string;
    colorStatus: {
        requestOrder: boolean;
        chef: boolean;
        newOrder: boolean;
        support: boolean;
        available: boolean;
    };
    summary: {
        status: statusSummary;
        longestTime: string;
    };
}

export type FloorType = {
    _id: string;
    name: string;
    tables: TableType[];
};

export interface statusSummary {
    pending: number;
    accepted: number;
    cooking: number;
    ready: number;
    done: number;
    returned: number;
}

export interface StatusTracking {
    pending?: string;
    accept?: string;
    cook?: string;
    ready?: string;
    done?: string;
}

export interface orderType {
    _id: string;
    name: string;
    orderStatus: number;
    createdAt: string;
}

export interface ReceiveOrderType {
    status: number;
    data: {
        detailId: string;
        orderId: string;
        productName: string;
        productNameKH: string;
        name: string;
        nameKH: string;
    }[];
}

export interface ReceiveChefType {
    success: boolean;
    status: number;
    available: boolean;
    data: {
        businessId: string;
        message: string;
        tableId: string;
        tableName: string;
        productName: string;
        productNameKH: string;
    }[];
}

export interface optionValues {
    _id: string;
    name: string;
    nameKH: string;
    price: string;
    status: boolean;
    isCheck: boolean;
}

export interface TotalPriceResult {
    totalPrice: number;
    totalPriceItem: number;
    priceItem: number;
}

export interface orderOptionType {
    _id: string;
    businessId: string;
    name: string;
    nameKH: string;
    min: number;
    max: number;
    values: optionValues[];
}

export interface orderAddonType {
    _id: string;
    businessId: string;
    tableId: string;
    name: string;
    nameKH: string;
    isCheck: boolean;
    price: number;
    status: boolean;
    image: string;
    description: string;
    descriptionKH: string;
    quantity: number;
    categories: {
        _id: string;
        name: string;
    }[];
    addonIds: string[];
    optionIds: string[];
}

export interface productType {
    _id: string;
    detailId: string;
    businessId: string;
    discountId: string;
    orderId: string;
    tableId?: string;
    description: string;
    descriptionKH?: string;
    title: string;
    name: string;
    nameKH: string;
    price: number;
    priceItem: number;
    totalPriceItem: number;
    quantity: number;
    status: number;
    isSelect: boolean;
    instruction: string;
    image: string;
    tracking: {
        pending: string;
        reject: string;
        accept: string;
        process: string;
        completed: string;
    };
    categories: {
        _id: string;
        name: string;
    }[];
    addonIds: string[];
    optionIds: string[];
    options: orderOptionType[];
    addons: orderAddonType[];
    isCheck: boolean;
    isWaiter: boolean;
    code: string;
    alertQty: number;
    discountPercent: number;
    inventoryStock: {
        _id: string;
        available: number
        quantity: number;
    };
    discountPrice: number;
    discountValue: number;
    is_discount: boolean;
    fullPrice: number;
    isTrackStock: boolean;
    isReturnable: boolean;
    requiresCooking: boolean;
    originalPrice: number;
}

export interface PromotionType {
    _id: string;
    businessId: string;
    name: string;
    description: string;
    eligibleProducts: productType[];
    discount: number;
    status: boolean;
}

export interface promotionDiscountType {
    _id: string;
    businessId: string;
    name: string;
    description: string;
    eligibleProducts: productType[];
    discount: number;
    startDate: Date;
    endDate: Date;
    status: boolean;
    __v: number;
}

export interface acceptOrderType {
    status: number;
    data: {
        orderId: string;
        detailId: string;
        quantity: number;
    }[];
}

export interface PaymentConfig {
    accountID: string;
    merchantID: string;
    merchantName: string;
    merchantCity: string;
    acquiringBank: string;
    currencyCode: number; // 840, 116
}

export interface Links {
    map: string;
    youtube: string;
    facebook: string;
    instagram: string;
}

export interface PerformanceConfig {
    maxServiceTime: number;
    maxDeliveryTime: number;
}

export type ICurrencyRate = {
    _id: string;
    code: string;
    rateToUSD: number;
    country: string;
    countryCode: string;
    symbol: string;
    active: boolean;
};

export interface Business {
    _id: string;
    name: string;
    type: string;
    address: string;
    phoneNumber: string;
    vat: number;
    exchangeRate: number;
    cuisineType: string[];
    paymentConfig: PaymentConfig;
    links: Links;
    images: {
        logo: string;
    };
    status: boolean;
    performanceConfig: PerformanceConfig;
    currency: ICurrencyRate;
    currencyBase?: ICurrencyRate;
}
